import StatusBadge from "../../components/common/StatusBadge";

const defaultRender = (value) => (value ? value : "--");

const totalfiles = [
  {
    title: "File Name",
    dataIndex: "service_name",
    render: defaultRender,
    fixed: "left",
  },
  // {
  //   title: "File No.",
  //   dataIndex: "file_number",
  //   render: defaultRender,
  // },
  {
    title: "Created On",
    dataIndex: "date_created",
    render: defaultRender,
  },
  {
    title: "Current Stage",
    dataIndex: "running_task_name",
    render: defaultRender,
  },
  {
    title: "Progress",
    dataIndex: "progress",
    render: defaultRender,
    width: 250,
  },
  {
    title: "Status",
    dataIndex: "files_status",
    render: (value) => (value ? <StatusBadge status={value} /> : "--"),
  },
  {
    title: "Action",
    dataIndex: "action",
    render: defaultRender,
  },
];

export default totalfiles;
